import {IUserModel} from "../user-model.interface";
import {IServiceFactory} from "../../../service-factory.interface";
import {IDotRezUserSession} from "../../../dot-rez-api/session/user-session/dot-rez-user.session.interface";
import {DotRezUserSession} from "../../../dot-rez-api/session/user-session/dot-rez-user.session";
import {IReactionDisposer, makeObservable, observable, reaction, runInAction} from "mobx";
import {NullableString} from "../../../../types/nullable-types";
import {WellKnownQueryParams} from "../../../window/window.service.interface";


export class AnonymousUserModel implements IUserModel {
    constructor(public readonly services: IServiceFactory) {
        this._getSessionPromise = this._createUserSession();
        makeObservable<this, '_getSessionPromise'>(this, {
            _getSessionPromise: observable.ref
        });

        this._reactions.push(reaction(() => this.currentAgentName,
            async () => {
                await this.reCreateSession();
            }));
    }

    public  readonly isAuthorized: boolean = false;

    private _reactions: IReactionDisposer[] = [];

    private _getSessionPromise: Promise<IDotRezUserSession>;
    getSession(): Promise<IDotRezUserSession> {
        return this._getSessionPromise;
    }

    private get currentAgentName() : NullableString {
        return this.services.window.getUrlParam(WellKnownQueryParams.Agent) ?? null;

    }

    private async _createDotRezToken(): Promise<string> {
        if(this.currentAgentName) {
            try {
                return await this.services.dotRezApi.getDeepLinkAgentToken({
                    agentName: this.currentAgentName
                });

            } catch (err) {
                this.services.logger.error(`Failed to create token for agent ${this.currentAgentName}`, err);
            }

        }
        return await this.services.dotRezApi.createAnonymousToken()
    }

    private async _createUserSession(): Promise<IDotRezUserSession> {
        const token = await this._createDotRezToken();
        return new DotRezUserSession(token, this.services);
    }

    reCreateSession(): Promise<IDotRezUserSession> {
        const promise = this._createUserSession();
        runInAction(() => {
            this._getSessionPromise = promise;
        });

        return promise;
    }

    dispose(): void {
        this._reactions.forEach(r => r());
    }
}
